const homepage = {
    title: 'What it\'s like to be a student in Latvia?',
    starterIntro: 'EUROSTUDENT is an international research project on the social and economic conditions of student life. It is conducted simultaneously in most European countries.',
    starterTeaser: 'Take part in the survey and win!',

    access: 'Access to higher education',
    accessDescription: '',
    time: 'Time budget ',
    timeDescription: '',
    employment: 'Employment',
    employmentDescription: '',
    budget: 'Income and expenditure',
    budgetDescription: '',
    conditions: 'Living conditions',
    conditionsDescription: '',
    mobility: 'Foreign mobility',
    mobilityDescription: '',

    ctaThankYou: 'We thank everyone who took part in EUROSTUDENT 9 survey!',
}

export default homepage
